import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../_common/application/ts/Glob';
import * as Utils from '../../../_common/application/ts/Utilities';
import * as AttrQueryValuesFormat from '../../../_common/platform/ts/AttrQueryValuesFormat';
import * as DateTimeFunctions from '../../../_common/platform/ts/DateTimeFunctions';

const Globalize = require('pdc-platform-Globalize');
import * as Globalization from '../../../_common/platform/ts/Globalization';

import GlobalState from '../../../_common/platform/ts/globalStates/GlobalState';
import { themeFields } from './themes/themeFields';
import { chartConstants } from './chartConstants';
import { ChartPropsManager } from './ChartPropsManager';
import { DataQuerySingleValueField } from '../../../_common/application/tsx/DataQuerySingleValueField';
import { ChartElementsFormatKeys } from './components/ChartElementsFormatSelect';
import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import { IDataParameters } from '../../../_common/platform/ts/AqlUtility';
import { IScopeOptions } from '../../../_common/platform/tsx/filtering/Interfaces';
import { ATTRIBUTE_TYPES, TIME_PART_FORMATS } from '../../../_common/platform/ts/ConfigurationConstants';
import { getPalette, generateColors } from 'devextreme/viz/palette';
import { IWidgetOptionsBase } from '../../../pdc-platform/src/ts/Interfaces';
import { IWidgetParameters, IWParams } from './components/Interfaces';
import { ChartOptionsController } from './components/ChartOptionsController';
import { StripsWrapper } from './components/StripsWrapper';

declare var DevExpress: any;

//LL: roleIndices in DataItem
//  maybe not enum but object or like type XXXXX = 'constant' | 'variable' | 'timePart';

//LL: multi C2F - now both single and multi
//   let C2F_dd_arr = []; //LL: in main
//   let C2F_dd_nogroup_arr = []; //LL: in main

//LL:  Order in Data Item, see translateQuery  in main:
//    group_attribs:   x1  x3_dd   x2_dd (4, 5)  T_dd,  a_dd  C2F_dd_arr
//    attrib_refs:  Y   Y3  X1(none aggr)  X3(none aggr)  X2(none aggr)   Y(none aggr)   Y3(none aggr)
//                  zSize  4Yfiscal  2Yrange  XC  XL  XP  stackP  C2F T(no group) A(no group) SBT(no group) C2F_dd_nogroup_arr
export enum RolesType {
    Y = 0,
    Y3,
    X1,
    X2,
    X3, // noGroup ?  2 3 4
    XP_group, //  for scatter
    zSize,
    yFiscal, //LL: only yFiscal ?   7
    yRange,
    XL,
    XC,
    XP,
    stackP,
    C2F,
    T, // T_group, T_nogroup  ?  no, only 1   9 10 11   14-T
    A_group,
    A_nogroup, //  15 16
    SBT, //LL: SubTitles
    C2F_group, //LL: when C2F_Multi = true
    C2F_nogroup // 19 //LL: when C2F_Multi = true
}

//LL: add "export" for D3
export class NotificationCallWrapper {
    private static notificationCallObj: any = null;

    public static setNotificationCallObj(NotificationCallObj) {
        //LL:  NotificationCallObj is this.props.glob.AppActions called from Module.tsx of Charts
        if (NotificationCallObj != null) {
            if (NotificationCallWrapper.notificationCallObj == null) {
                NotificationCallWrapper.notificationCallObj = NotificationCallObj;
            }
        }
        return true;
    }

    //   msgType: 'warning', "fail"
    public static notify(msgType, msg, isActionRequired) {
        //LL:  in msg - <br>, not '\n'  -- will be inside <span> :
        let opt = {};
        if (isActionRequired === true) {
            opt = { manualDestroy: true };
        } // it is option obj
        if (NotificationCallWrapper.notificationCallObj != null) {
            NotificationCallWrapper.notificationCallObj.notification(msgType, msg, opt);
        }
    }
}

//LL: not const
//export var C2F_Multi = false; // old
export var C2F_Multi = true; // new

export class ColorManager {
    //LL: 29.07.19:
    //  "Widget Palette" section was commented by OE 24.10.18
    //   Vars of this section remain, see widgetTheme.ts  section: 'widgetPalette'
    //
    //  So, no sense to use them.

    public static themeFields_forDefaultColors = {
        axis: {
            themeFieldForDefault_color: 'widget-palette-element-color_2', //LL: used in ChartAxisField getColor  mix
            themeFieldForDefault_colorSeries: 'widget-palette-element-special-color_2', //LL: used in ChartAxisField getColorSeries  #ff0080   no
            themeFieldForDefault_colorBreaks: 'widget-palette-element-color_4', //LL: used in ChartAxisField getBreaksColor  #ababab  must be same as axis or darker ?
            defaultColors_static: {
                color: '#d3d3d3', //LL: DevExpress default
                colorSeries: '#ff0080',
                colorBreaks: '#ababab' //LL: DevExpress default
            }
        },

        axis_new: {
            themeFieldForDefault_color: themeFields.axis_axisColor,
            themeFieldForDefault_colorLabels: themeFields.axis_axisLabelColor,
            themeFieldForDefault_colorSeries: themeFields.axis_seriesColorAux,
            themeFieldForDefault_colorBreaks: themeFields.axisBreaks_color,
            defaultColors_static: {
                color: '#d3d3d3', //LL: DevExpress default
                colorlabels: '#d3d3d3',
                colorSeries: '#ff0080',
                colorBreaks: '#ababab' //LL: DevExpress default
            }
        },

        //LL: ColorManager.themeFields_forDefaultColors.strip_constLine is used in main in
        //  and in ChartStripsField and constLines
        strip_constLine: {
            themeFieldForDefault_colorBack: 'widget-palette-medium-element-back-color', //LL: used in ChartStripsField, in main getColor  mix  axisStrips_color
            themeFieldForDefault_colorLine: 'widget-palette-medium-element-border-color', //LL: constLines  mix
            //themeFieldForDefault_colorFont: "widget-palette-medium-element-fore-color",  //LL: strips, constLines getFontColor mix
            themeFieldForDefault_colorFont_strips: 'widget-palette-medium-element-fore-color',
            themeFieldForDefault_colorFont_constantLines: 'widget-palette-medium-element-fore-color',
            defaultColors_static: {
                colorBack: '#dae0f7',
                colorFont: '#000000',
                colorLine: '#000000'
            }
        },

        strip_constLine_new: {
            themeFieldForDefault_colorBack: themeFields.axisStrips_color,
            themeFieldForDefault_colorLine: themeFields.axisConstantLines_color,
            themeFieldForDefault_colorFont_strips: themeFields.axisStrips_fontColor,
            themeFieldForDefault_colorFont_constantLines: themeFields.axisConstantLines_fontColor,
            defaultColors_static: {
                colorBack: '#dae0f7',
                colorFont: '#000000',
                colorLine: '#000000'
            }
        },

        //LL: used in main.ts in tooltips_backcolor, tooltips_fontColor,  tooltips.backcolor (static), tooltips.fontColor (static)
        tooltip: {
            themeFieldForDefault_backColor: 'surface-bg',
            themeFieldForDefault_foreColor: 'gray-base',
            //themeFieldForDefault_borderColor: "widget-palette-tooltips-border-color",  // mix    not used ?
            defaultColors_static: {
                backColor: '#ffffff',
                foreColor: '#232323' // default in DevExpress
            }
        },

        tooltip_new: {
            themeFieldForDefault_backColor: themeFields.tooltips_backcolor,
            themeFieldForDefault_foreColor: themeFields.tooltips_fontColor,
            defaultColors_static: {
                backColor: '#ffffff',
                foreColor: '#232323' // default in DevExpress
            }
        },

        crosshair: {
            defaultColors_static: {
                lineColor: '#f05b41', // default in DevExpress
                backColor: '#f05b41', // default in DevExpress
                foreColor: '#ffffff' // default in DevExpress
            }
        },

        //LL: ColorManager.themeFields_forDefaultColors.pointLabels is used in main in
        //   labelPie_fontColor, labelXY_fontColor, labelXY_backgroundColor, labelXY_fontColor_for_onlyOneLabelPerStack
        //   labelXY_backgroundColor_for_onlyOneLabelPerStack, labelXY_borderColor, d3_labelColor
        //      static: labelXY.fontColor, labelXY.backgroundColor, etc
        pointLabels: {
            //   labelXY, labelPie, labelD3
            themeFieldForDefault_backColor: 'widget-palette-small-element-back-color', // mix
            themeFieldForDefault_foreColor: 'widget-palette-small-element-fore-color', //  'gray-base'
            themeFieldForDefault_borderColor: 'widget-palette-small-element-border-color', // mix
            themeFieldForDefault_foreColor_Pie: 'widget-palette-white', // #ffffff
            themeFieldForDefault_foreColor_D3: 'widget-palette-black', // #000000
            defaultColors_static: {
                backColor: '#ffffff',
                foreColor: '#000000',
                borderColor: '#d3d3d3',
                foreColor_Pie: '#ffffff',
                foreColor_D3: chartConstants.d3_constants.d3_default_labelColor
            }
        },

        pointLabels_new: {
            //   labelXY, labelPie, labelD3
            themeFieldForDefault_backColor: themeFields.pointLabels_color_backgroundColor,
            themeFieldForDefault_foreColor: themeFields.pointLabels_color_fontColor,
            themeFieldForDefault_borderColor: themeFields.pointLabels_color_borderColor,
            themeFieldForDefault_foreColor_Pie: themeFields.pointLabels_Pie_fontColor,
            themeFieldForDefault_foreColor_D3: themeFields.pointLabels_D3_labelColor,
            defaultColors_static: {
                backColor: '#ffffff',
                foreColor: '#000000',
                borderColor: '#d3d3d3',
                foreColor_Pie: '#ffffff',
                foreColor_D3: chartConstants.d3_constants.d3_default_labelColor
            }
        }
    };
}

export class DevExprPaletteManager {
    public static getDefaultSeriesColor() {
        let sColor = '#5f8b95'; // ba4d51

        //LL: 29.12.15: DevExpr 15.2: DevExpress.viz.core.getPalette deprecated, use DevExpress.viz.getPalette
        // http://js.devexpress.com/Documentation/ApiReference/Common/Utils/viz/Methods/?version=15_2
        // #getPalettepaletteName
        let viz_getPalette;

        //if (DevExpress != null && DevExpress.viz != null) {
        //    if (DevExpress.viz.getPalette != null) {
        //        //let pal = DevExpress.viz.getPalette("default");
        //        //LL: DevExpress 18.1.5:
        //        //    The ""palette"" option does not accept the "Default" value since v.18.1. Use the "Office" value instead
        //        //    Added:  'Material', 'Office'    Default Value: 'Material'
        //        let pal = DevExpress.viz.getPalette('Office');
        //
        //        if (pal != null) {
        //            viz_getPalette = true;
        //            let simpleSetColors = pal.simpleSet;
        //            if (simpleSetColors != null && simpleSetColors.length > 0) {
        //                sColor = simpleSetColors[0];
        //            }
        //        }
        //    }
        //}

        //LL: 31.01.24:  DevExpress.viz.getPalette -> getPalette from "devextreme/viz/palette"
        // https://js.devexpress.com/DevExtreme/ApiReference/Common/Utils/viz/?search=getPalette/
        if (getPalette != null) {
            let pal = getPalette('Office');
            if (pal != null) {
                viz_getPalette = true;
                let simpleSetColors = pal.simpleSet;
                if (simpleSetColors != null && simpleSetColors.length > 0) {
                    sColor = simpleSetColors[0];
                }
            }
        }

        //LL:
        // '#000000', '#ff0000'  5f8b95-as default palette, ba4d51-as default palette second color (~red)
        //  How to get this color:
        // http://js.devexpress.com/Documentation/Howto/Data_Visualization/Common/Appearance_Customization/
        // ?version=14_1#Palettes
        if (viz_getPalette != true) {
            console.log('   LL viz_getPalette != true,  old DevExpr is used');
            if (DevExpress != null && DevExpress.viz != null && DevExpress.viz.core != null) {
                let simpleSetColors = DevExpress.viz.core.getPalette('default', { type: 'simpleSet' });
                if (simpleSetColors != null && simpleSetColors.length > 0) {
                    sColor = simpleSetColors[0];
                }
            }
        }

        return sColor;
    }

    //LL:  DevExpress 18.1.5:"blend" is default in DevExpr, "alternate" works same as in ver 17
    public static paletteExtensionMode_default = 'alternate'; // or "extrapolate" ?

    //LL: pure initial colors:
    public static getPaletteColors(paletteName) {
        //if (paletteName == null) paletteName = "default";
        //LL:  DevExpress 18.1.5:
        //    The ""palette"" option does not accept the "Default" value since v.18.1. Use the "Office" value instead
        //    Added:  'Material', 'Office'    Default Value: 'Material'
        if (paletteName == null || paletteName === 'default') {
            paletteName = 'Office';
        }

        //if (DevExpress != null && DevExpress.viz != null && DevExpress.viz.getPalette != null) {
        //    let pal = DevExpress.viz.getPalette(paletteName);
        //    if (pal != null) {
        //        return pal.simpleSet;
        //    }
        //}
        //LL: 31.01.24:  DevExpress.viz.getPalette -> getPalette from "devextreme/viz/palette"
        if (getPalette != null) {
            let pal = getPalette(paletteName);
            if (pal != null) {
                return pal.simpleSet;
            }
        }

        return null;
    }

    //LL: 27.03.23: Use always getVariatedColors2 - DevExpress opened their color eval function
    //LL: 28.04.23: old function getVariatedColors fully removed
    public static getVariatedColors2(paletteName, paletteExtensionMode: any, nSeries) {
        if (paletteName == null || paletteName === 'default') {
            paletteName = 'Office';
        }
        let colors = [];

        //LL: see https://js.devexpress.com/Documentation/ApiReference/Common/utils/viz/#generateColorspalette_count_options
        //if (DevExpress != null && DevExpress.viz != null && DevExpress.viz.generateColors != null) {
        //    colors = DevExpress.viz.generateColors(paletteName, nSeries,
        //        {baseColorSet: 'simpleSet', paletteExtensionMode: paletteExtensionMode});
        //}
        //LL: 31.01.24:  DevExpress.viz.getPalette -> getPalette from "devextreme/viz/palette"
        if (generateColors != null) {
            let options: any = { baseColorSet: 'simpleSet', paletteExtensionMode: paletteExtensionMode };
            colors = generateColors(paletteName, nSeries, options);
        }

        return colors;
    }
}

//LL: contains static functions
export class ChartFunctionsWrapper {
    public static getMilliseconds(value: any) {
        // millisec from 1.1.70
        if (typeof value === 'string') {
            return new Date(value).getTime();
        } else {
            return value.getTime();
        }
    }

    //LL: categoriesExtended: to speed, without loop on dataSource
    //              categoriesExtended created in getCategories
    public static extendDataSource_BySeries_2(
        categoriesExtended,
        series,
        dataSource,
        emptyValuesAsZero,
        onlyOneLabelPerStack
    ) {
        //LL: dataSource will be changed, extended !

        //LL  bug reported by OE - https://www.devexpress.com/Support/Center/Question/Details/T170408
        //   recommendation by DevExpress: Change data so that each argument has a defined value or "null" for each series.
        //LL: series ~~ { name: "Anne B", valueField: "Anne B" }
        //    dataSource ~~ { Anne B: 1, name: 117500 }
        //    categories ( = list of Arguments) ~~ [117500, 105000,]

        //LL: for all ChartTypes, were complaints that args order is wrong

        for (let key in categoriesExtended) {
            let arg = key;
            let catExt = categoriesExtended[key];

            if (catExt != null) {
                //LL: unite added data items: 1 data item for eack arg:
                let d = { name: arg };
                let toAdd = false;
                for (let j = 0; j < series.length; j++) {
                    let valueField = series[j].valueField;

                    //LL: for "onlyOneLabelPerStack"
                    let stackValue = series[j].stack;
                    let emptyStack = false; //LL: no values in DataSource for this Stack for this Arg(Category)
                    if (stackValue != null && stackValue !== '') {
                        if (catExt.stacks != null && catExt.stacks[stackValue] === false) {
                            emptyStack = true;
                        }
                    }

                    //LL: for "onlyOneLabelPerStack":
                    let isUpperInStack = false;
                    if (series[j].tag.upperInStack === true) {
                        isUpperInStack = series[j].tag.upperInStack;
                    }

                    //LL: "true" was set, when dataSource item with these 'name' and valueField is found
                    if (catExt.fields == null || catExt.fields[valueField] != true) {
                        //d[valueField] = null;
                        //d[valueField] = 0;  //LL try - better view, but it's up to backend

                        //LL: "onlyOneLabelPerStack" when Stack & SBS, for bars,
                        //LL:    Must have values for all series, at least 0, so set emptyValuesAsZero to true
                        if (
                            (onlyOneLabelPerStack === true && isUpperInStack && !emptyStack) ||
                            (emptyValuesAsZero === true && ChartOptionsController.isContinuousChartType(series[j].type))
                        ) {
                            d[valueField] = 0;
                        } else {
                            d[valueField] = null;
                        }
                        toAdd = true;
                    }
                }
                if (toAdd) {
                    dataSource.push(d);
                }
            }
        }
    }

    public static evalArgumentsType(wParams, glob: IGlob) {
        // return { argType: argType, argTimePart: argTimePart  }
        let argType = 's';
        let argTimePart; //LL: format for Time Parts is in wParams.argumentAxis.labelsFormat
        let argType_externalEvaluated;
        let o = ChartPropsManager.get_argumentType_Multi(wParams.externalFunctions.attrQueryMulti, glob);
        // if (typeof wParams.externalFunctions.get_argType_MultiFunc === 'function') {
        //     o = wParams.externalFunctions.get_argType_MultiFunc(wParams.externalFunctions.attrQueryMulti);
        // }
        //LL: o - { type: type, isDate: isDate, timePart: timePartMix };
        if (o != null) {
            argType_externalEvaluated = o.type;
            if (DateTimeFunctions.isTypeOfAnyDate(argType_externalEvaluated) && o.isDate !== true) {
                argType_externalEvaluated = 's';
            }
            argTimePart = o.timePart;
        }

        if (!ChartPropsManager.ApplyFormattedTimeParts && argTimePart != null && argTimePart !== 'none') {
            argType_externalEvaluated = 'i';
        }

        if (argType_externalEvaluated != null) {
            argType = argType_externalEvaluated;
        }

        return { argType: argType, argTimePart: argTimePart };
    }

    public static evalValuesType(wParams, dataTypes, glob: IGlob) {
        let dType = 's';
        let yTimePart;

        if (dataTypes != null && dataTypes.length > 0) {
            dType = dataTypes[0];

            let diff = false;

            if (dataTypes.length > 1) {
                //LL: unite i and r as r
                for (let i = 1; i < dataTypes.length; i++) {
                    if (dType != dataTypes[i]) {
                        if (dType === 'i' && dataTypes[i] === 'r') {
                            dType = 'r';
                        } else if (!(dType === 'r' && dataTypes[i] === 'i')) {
                            // do nothing in such (!) case
                            diff = true;
                            break;
                        }
                    }
                }
            }

            if (diff) {
                dType = 's';
            } //LL: or some other special, ex 'diff'
        }

        //LL: for Dates and integer
        let yType_externalEvaluated;
        let o = ChartPropsManager.get_yType_Multi(wParams.externalFunctions.attrQueryMulti, glob);
        // if (typeof wParams.externalFunctions.get_yType_MultiFunc === 'function') {
        //     o = wParams.externalFunctions.get_yType_MultiFunc(wParams.externalFunctions.attrQueryMulti);
        // }

        if (o != null) {
            yType_externalEvaluated = o.yType;
            if (DateTimeFunctions.isTypeOfAnyDate(yType_externalEvaluated) && o.isDate !== true) {
                yType_externalEvaluated = 's';
            }
            yTimePart = o.timePart;
        }

        if (!ChartPropsManager.ApplyFormattedTimeParts && yTimePart != null && yTimePart !== 'none') {
            yType_externalEvaluated = 'i';
        }

        if (yType_externalEvaluated != null) {
            dType = yType_externalEvaluated;
        }

        return { yType: dType, yTimePart: yTimePart };
    }

    public static evalAuxAxisType(wParams, axisName, glob: IGlob) {
        let aaType = 's';
        let aaTimePart;
        let o = ChartPropsManager.get_yType_Multi_SecondaryAxis(
            wParams.externalFunctions.attrQueryMulti,
            axisName,
            glob
        );
        // if (typeof wParams.externalFunctions.get_yType_Multi_SecondaryAxis_Func === 'function') {
        //     o = wParams.externalFunctions.get_yType_Multi_SecondaryAxis_Func(
        //         wParams.externalFunctions.attrQueryMulti,
        //         axisName
        //     );
        // }
        if (o != null) {
            aaType = o.yType;
            if (DateTimeFunctions.isTypeOfAnyDate(aaType) && o.isDate !== true) {
                aaType = 's';
            }
            aaTimePart = o.timePart;
        }

        if (!ChartPropsManager.ApplyFormattedTimeParts && aaTimePart != null && aaTimePart !== 'none') {
            aaType = 'i';
        }

        return { yType: aaType, yTimePart: aaTimePart };
    }

    public static evalCanAsPercent_ForArgumentAxis(wParams, argType) {
        //LL: see there: prohibit if not 'continuous' || 'logarithmic';
        //LL: AxisType == 'continuous' for i,r and datetime of special formats
        let canAsPercentX = !ChartPropsManager.prohibitAsPercent_byAxisType(wParams.argumentAxis.axisType);

        //LL: I think we must also prohibit datetime axis to have AsPercent
        if (canAsPercentX) {
            //LL: prohibite datetime:
            canAsPercentX = !ChartPropsManager.prohibitAsPercent_byDataType(argType);
        }
        return canAsPercentX;
    }

    public static evalCanAsPercent_ForValueAxis(wParams, yType) {
        let canAsPercentY = true; //LL: instead of prohibit by AxisType

        if (canAsPercentY) {
            //LL: prohibite datetime:
            canAsPercentY = !ChartPropsManager.prohibitAsPercent_byDataType(yType);
        }

        canAsPercentY = !ChartPropsManager.prohibitAsPercent_byAxisType_byDataType(wParams.valueAxis.axisType, yType);
        return canAsPercentY;
    }

    public static evalCanAsPercent_ForAuxAxis(wParams: IWParams, axisName: string, glob: IGlob) {
        let canAsPercent = true;
        let oValueType = ChartFunctionsWrapper.evalAuxAxisType(wParams, axisName, glob);
        let aaType = oValueType.yType;
        let aaTimePart = oValueType.yTimePart;

        if (aaTimePart != null) {
            canAsPercent = false;
        }

        if (canAsPercent) {
            canAsPercent = !ChartPropsManager.prohibitAsPercent_byDataType(aaType);
        }

        let axisType;
        let param_auxValueAxis = wParams.valueAxis.auxAxis;

        if (param_auxValueAxis != null && param_auxValueAxis.length > 0) {
            for (let k = 0; k < param_auxValueAxis.length; k++) {
                if (param_auxValueAxis[k].name === axisName) {
                    axisType = param_auxValueAxis[k].type;
                    break;
                }
            }
        }
        canAsPercent = !ChartPropsManager.prohibitAsPercent_byAxisType_byDataType(axisType, aaType);

        return canAsPercent;
    }

    public static getAdaptiveLayoutObj(_theme) {
        //LL: oh, keepLabels, false by default is for Pie;  for XY default is true !
        let adaptiveLayoutObj: any; // without keepLabels, false by default.  Only size
        //let adaptiveLayout_size; //LL: DevExpress default is 80px for both
        let adaptiveLayout_size_field = themeFields.adaptiveLayout_size;

        if (_theme[adaptiveLayout_size_field] != null) {
            let adaptiveLayout_size = _theme[adaptiveLayout_size_field];

            if (adaptiveLayout_size.width != null || adaptiveLayout_size.height != null) {
                adaptiveLayoutObj = {};
            }
            if (adaptiveLayout_size.width != null) {
                adaptiveLayoutObj.width = adaptiveLayout_size.width;
            }
            if (adaptiveLayout_size.height != null) {
                adaptiveLayoutObj.height = adaptiveLayout_size.height;
            }
        }

        return adaptiveLayoutObj;
    }
}

//LL:  to use for Tooltips and PointLabels and Legend
export class LabelsFormatWrapper {
    //LL: to rem, formatConfig always null  7th param wParams?,
    //LL:
    //     order of args;
    //     wParams?, formatConfigKey?  not necessary - call without them where old formatting wasn't implemented
    //     add defaultFormatted
    //LL:  new try formats
    //    formatsField for NEW,     formatConfigKey for OLD - must be removed later ("sbs" or "stacked")
    //    formatConfigKeyMinor from OLD, used to differ tooltip/pointLabel
    public static getFormatted(
        V,
        defaultFormatted,
        seriesTag,
        formatsField,
        currency,
        formatConfigKeyMinor,
        formatConfigKey?
    ) {
        if (V == null) {
            V = '';
        }
        let Formatted: any = defaultFormatted == null ? V.toString() : defaultFormatted;

        if (seriesTag == null) {
            return Formatted;
        }

        if (formatsField != null && seriesTag[formatsField] != null) {
            let formatObj: any;

            let elemKey;
            if (formatConfigKeyMinor === 'Tooltip') {
                elemKey = ChartElementsFormatKeys.inTooltip;
            } else if (formatConfigKeyMinor === 'Labels') {
                elemKey = ChartElementsFormatKeys.inPointLabels;
            } else if (formatConfigKeyMinor === 'argLabel') {
                elemKey = ChartElementsFormatKeys.argLabel;
            } else if (formatConfigKeyMinor === 'Legend') {
                elemKey = ChartElementsFormatKeys.inLegend;
            }

            if (elemKey != null) {
                formatObj = seriesTag[formatsField][elemKey];
                if (formatObj == null) {
                    formatObj = seriesTag[formatsField][ChartElementsFormatKeys.everywhere];
                }
            }

            if (formatObj != null) {
                Formatted = LabelsFormatWrapper.getFormattedValue_by_FormatObj(V, formatObj, currency);
            }
        }

        return Formatted;
    }

    public static getDefaultFormat(dataType, theme) {
        if (theme == null) {
            return null;
        }

        let format: any;

        switch (dataType) {
            case 'r':
                format = theme[themeVars.formats_real];
                break;
            case 'i':
                format = theme[themeVars.formats_integer];
                break;
            case 'dateTime':
                format = theme[themeVars.formats_datetime];
                break;
            case 'date':
                format = theme[themeVars.formats_date];
                break;
            case 'time':
                // + use24HoursFormat
                format = theme[themeVars.formats_time];
                break;
            case 'b':
                format = theme[themeVars.formats_boolean];
                break;
        }
        return format;
    }

    public static getFormattedArgument(pointInfo, wParams, chartWidgetObj, argTimePart, formatConfigKeyMinor?) {
        let argText = pointInfo.argumentText;

        let axis = wParams.argumentAxis;
        let currency = wParams.currency;

        if (axis.labelsCurrency != null) {
            currency = axis.labelsCurrency;
        }

        let formatObj;
        let seriesTag = pointInfo.point.series.tag;

        if (seriesTag != null && seriesTag.x_formats != null) {
            let elemKey;
            if (formatConfigKeyMinor === 'Tooltip') {
                elemKey = ChartElementsFormatKeys.inTooltip;
            } else if (formatConfigKeyMinor === 'Labels') {
                elemKey = ChartElementsFormatKeys.inPointLabels;
            }
            if (elemKey != null) {
                formatObj = seriesTag.x_formats[elemKey];
                if (formatObj == null) {
                    formatObj = seriesTag.x_formats[ChartElementsFormatKeys.everywhere];
                }
            }
        }

        if (formatObj == null) {
            // as old   old
            let alf = wParams.argumentAxis.labelsFormat;
            if (alf == null || alf === '' || alf === 'default') {
                if (chartWidgetObj != null) {
                    argText = chartWidgetObj.getDevExpressFormattedArgument(pointInfo);
                }
            } else if (!ChartPropsManager.ApplyFormattedTimeParts && argTimePart != null && argTimePart !== 'none') {
                let val = LabelsFormatWrapper.convertDate(pointInfo.argument, argTimePart, alf);
                if (val != null) {
                    argText = val;
                }
            }
        } else {
            if (formatObj.type == null) {
                formatObj.type = pointInfo.point.series.argumentType;
            }
            argText = LabelsFormatWrapper.getFormattedValue_by_FormatObj(pointInfo.argument, formatObj, currency);
        }

        return argText;
    }

    public static getFormattedValue(
        pointInfo,
        wParams,
        chartWidgetObj,
        yTimePart,
        ownAxis,
        formatConfigKeyMinor,
        forTotalValue?
    ) {
        let valueText = pointInfo.valueText;
        let valueValue = pointInfo.value;

        if (forTotalValue === true) {
            if (pointInfo.total == null) {
                return null;
            }
            valueText = pointInfo.totalText;
            valueValue = pointInfo.total;
        }

        let useTotal = forTotalValue === true;

        //let tag = pointInfo.point.series.tag;
        //LL:  only for stacked bars: exist in pointInfo - total and totalText
        //  note:    onlyOneLabelPerStack was for both stack & sbs, now for stack without sbs
        //LL: only for Numbers
        let axis = wParams.valueAxis;
        let indexV = 0;
        if (ownAxis != null && wParams.valueAxis.auxAxis != null) {
            for (let i = 0; i < wParams.valueAxis.auxAxis.length; i++) {
                if (wParams.valueAxis.auxAxis[i].name === ownAxis) {
                    axis = wParams.valueAxis.auxAxis[i];
                    indexV = i + 1;
                }
            }
        }

        let currency = wParams.currency;
        if (axis.labelsCurrency != null) {
            currency = axis.labelsCurrency;
        }

        let isNumeric = axis.dataType === 'i' || axis.dataType === 'r';

        if (formatConfigKeyMinor === 'Labels') {
            if (wParams.onlyOneLabelPerStack === true && wParams.combineMultiQueriesAsStacked === true && isNumeric) {
                if (pointInfo.totalText != null) {
                    valueText = pointInfo.totalText;
                    useTotal = true;
                }
                if (pointInfo.total != null) {
                    valueValue = pointInfo.total;
                    useTotal = true;
                }
            }
        }
        //LL: fin onlyOneLabelPerStack ==================

        let formatObj;
        let seriesTag = pointInfo.point.series.tag;

        if (seriesTag != null && seriesTag.y_formats != null) {
            let elemKey;
            if (formatConfigKeyMinor === 'Tooltip') {
                elemKey = ChartElementsFormatKeys.inTooltip;
            } else if (formatConfigKeyMinor === 'Labels') {
                elemKey = ChartElementsFormatKeys.inPointLabels;
            }
            if (elemKey != null) {
                formatObj = seriesTag.y_formats[elemKey];
                if (formatObj == null) {
                    formatObj = seriesTag.y_formats[ChartElementsFormatKeys.everywhere];
                }
            }
        }

        if (formatObj == null) {
            // as old   old
            let alf = axis.labelsFormat;
            if (alf == null || alf === '' || alf === 'default') {
                if (chartWidgetObj != null) {
                    valueText = chartWidgetObj.getDevExpressFormattedValue(pointInfo, indexV, useTotal);
                }
            } else if (!ChartPropsManager.ApplyFormattedTimeParts && yTimePart != null && yTimePart !== 'none') {
                let val = LabelsFormatWrapper.convertDate(valueValue, yTimePart, alf);
                if (val != null) {
                    valueText = val;
                }
            } else if (axis.labelsHasCustomFormat === true) {
                let dataType = 'i';
                if (axis.dataType != null) {
                    dataType = axis.dataType;
                }
                //LL:  timePart as 5th param !
                let val = AttrQueryValuesFormat.formatValue(valueValue, valueValue.toString(), dataType, {
                    formatFront: alf
                });
                if (val != null) {
                    valueText = val;
                }
            } else if (alf.indexOf('currency') >= 0) {
                //LL: axis.labelsFormat has only 1 'currency' format, so enough ===
                let dataType = 'i';
                if (axis.dataType != null) {
                    dataType = axis.dataType;
                }
                let val = AttrQueryValuesFormat.formatValue(valueValue, valueValue.toString(), dataType, {
                    formatFront: alf,
                    currency: currency,
                    precision: axis.labelsPrecision
                });
                if (val != null) {
                    valueText = val;
                }
            }
            //LL:  needs when ownAxis, "pointInfo.valueText" may be wrong customized
            else if (ownAxis != null) {
                // cases when alf != default
                if (chartWidgetObj != null) {
                    valueText = chartWidgetObj.getDevExpressFormattedValue(pointInfo, indexV, useTotal);
                }
            }
        } else {
            valueText = LabelsFormatWrapper.getFormattedValue_by_FormatObj(valueValue, formatObj, currency);
        }

        return valueText;
    }

    public static getFormattedValue_by_FormatObj(value: any, formatObj, currency) {
        if (formatObj == null) {
            return value.toString();
        }

        let currencyLocal = currency;
        if (formatObj.currency != null) {
            currencyLocal = formatObj.currency;
        }
        //LL: currencyLocal was not used, so was not passed to AttrQueryValuesFormat.formatValue
        let formatObj2 = formatObj;
        if (formatObj.currency == null) {
            formatObj2 = $.extend(true, {}, formatObj);
            formatObj2.currency = currencyLocal;
        }

        //LL: they differ: when TimePart type = i, attrType = datetime
        //let t = formatObj.attrType;
        let t = formatObj.type;

        if (t === 'i' || t === 'r') {
            //LL:  === for r
            if (typeof value === 'string') {
                let num = Number(value);
                if (!isNaN(num)) {
                    value = num;
                }
            }
        }

        //LL: for 'b' - axis type is string and so values in pointInfo are strings
        if (t === 'b') {
            if (typeof value === 'string') {
                if (value === 'true') {
                    value = true;
                }
                if (value === 'false') {
                    value = false;
                }
            }
        }

        //LL: add firstDayOfWeek?:string to formatFront   cultureValues.firstWeekDay  from main.ts
        //     ga.formats[key].firstDayOfWeek = firstWeekDay;

        return AttrQueryValuesFormat.formatValue(value, value.toString(), t, formatObj2, formatObj2.timePart);
    }

    public static convertDate(value, timePart: string, format?: string, customFormat?: string) {
        //  when timePart: formatting needed for month (1-12), weekday (1-7). Maybe also for quarter (1-4), week (1-53): add Q or W
        //  "format" may be null

        let isDefaultFormat = false;

        if (format == null || format === '' || format === 'default') {
            isDefaultFormat = customFormat == null;
        }

        //LL: change 'default' format: let 'default' be always just value.toString()

        let n = value;
        //LL: want to be a string, not number, so that axis.label.format for numbers or dates won't apply
        //LL: not enough, set axis.argType = 'string'
        let res = value.toString();

        if (typeof value === 'string') {
            n = parseInt(value, 10);
        } // if (!isNaN(n))

        let f = format;

        if (isDefaultFormat) {
            f = 'default';
        }

        let fnd = false;

        switch (timePart) {
            case 'year':
                // old:
                switch (f) {
                    case TIME_PART_FORMATS.FOUR_DIGITS:
                        fnd = true;
                        break;
                    case TIME_PART_FORMATS.TWO_DIGITS:
                        fnd = true;
                        res = value.toString().substr(2);
                        break;
                }

                //LL: for f from ['longYear', 'shortYear'];
                fnd = fnd || isDefaultFormat;

                if (!fnd) {
                    //LL:  now formatNumeric appears not to convert TimeParts:
                    //LL: history:   common/application/ts/utilities.ts
                    //   25.06.17 OE made ~~ "Format reconstruction", during which FormatInt list was deleted
                    //   FormatInt contained all possible Integer formats including for TimeParts

                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }

                break;

            case 'yearFiscal':
                //    a = ['longYear', 'shortYear', 'longYearFiscal', 'shortYearFiscal'];
                fnd = isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }

                break;

            case 'halfyear':
                //    a = ['longHalfYear', 'shortHalfYear']
                fnd = isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }

                break;

            case 'halfYearFiscal':
                //    a = ['longHalfYear', 'shortHalfYear', 'longHalfYearFiscal', 'shortHalfYearFiscal'];
                fnd = isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }

                break;

            case 'quarter':
                //  new  a = ['Q_N', 'latin_N', 'Qlatin_N'];

                //LL: now formatNumeric appears not to convert TimeParts, so with "_N" also here:
                //LL: history:   common/application/ts/utilities.ts
                //   Qlatin_N, etc -  were added 22.03.16 to FormatInt list
                //   FormatInt was deleted by OE 25.06.17 during ~~ "Format reconstruction"
                //   Now Qlatin_N, etc are not processed anywhere !!!
                //LL:
                //   now OK in AttrQueryValuesFormat.convertIntToDate for formats without "_N"

                switch (f) {
                    case 'Q_N':
                        f = 'Q';
                        break;
                    case 'latin_N':
                        f = 'latin';
                        break;
                    case 'Qlatin_N':
                        f = 'Qlatin';
                        break;
                }

                //let tryAttrQueryValuesFormat = true;
                //if (tryAttrQueryValuesFormat) {
                fnd = isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }
                break;
            //}
            //break;

            case 'quarterFiscal':
                //    a = ['Q_N', 'latin_N', 'Qlatin_N', 'Q_Fiscal', 'latin_Fiscal', 'Qlatin_Fiscal'];
                fnd = isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.convertIntToDate(
                        n,
                        'i',
                        {
                            formatFront: f,
                            precision: 0
                        },
                        timePart
                    );
                }

                break;

            case 'month':
                // old:
                switch (f) {
                    case 'longName':
                    case 'longMonth':
                        fnd = true;
                        res = Globalization.getMonthName_Wide(n);
                        break;

                    case 'shortName':
                    case 'shortMonth':
                        fnd = true;
                        res = Globalization.getMonthName_Abbreviated(n);
                        break;

                    case 'numbers': // old
                    case 'monthNumber': // new
                        fnd = true;
                        res = DateTimeFunctions.TwoDigits(n);
                        break;
                }

                fnd = fnd || isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.formatNumeric(n, {
                        formatFront: f,
                        precision: 0
                    });
                }
                break;

            case 'weekday':
                // old:
                switch (f) {
                    case 'longName':
                    case 'longWeekDay':
                    case 'longweekDay':
                        fnd = true;
                        res = Globalization.getWeekDayName_Wide(n - 1);
                        break;

                    case 'shortName':
                    case 'shortWeekDay':
                    case 'shortweekDay':
                        fnd = true;
                        res = Globalization.getWeekDayName_Abbreviated(n - 1);
                        break;

                    case 'minName':
                    case 'minWeekDay':
                        fnd = true;
                        res = Globalization.getWeekDayName_Narrow(n - 1);
                        break;

                    case 'numbers':
                    case 'weekDayNumber':
                        fnd = true;
                        break;
                }

                fnd = fnd || isDefaultFormat;

                if (!fnd) {
                    res = AttrQueryValuesFormat.formatNumeric(n, {
                        formatFront: f,
                        precision: 0
                    });
                }

                break;

            case 'hour':
                res = AttrQueryValuesFormat.formatValue(n, n, ATTRIBUTE_TYPES.INTEGER, {
                    formatFront: f,
                    customFormat: customFormat
                });
                break;
            //default:
        }
        return res;
    }

    //LL: from ChartAxisWrapper, used for XY-Axis and Pie-Labels
    public static getFormatterFunction(format, dataType, timeInterval, customFormat, formatOptions?: any) {
        // is function in axis.label.format.formatter or just axis.label.format
        return function (value) {
            //LL: 01.07.20: now 'f' is outdated:
            if (format === 'f') {
                // shortDateTime  f	Long Date, Short Time	dddd, MMMM dd, yyyy h:mm tt
                return value.toDateString() + ', ' + value.toLocaleTimeString();
            } else if (format === 'S') {
                // Universal sortable format  "yyyy'-'MM'-'dd'T'HH':'mm':'ss"  It is identical in every culture
                return (
                    value.getFullYear() +
                    '-' +
                    DateTimeFunctions.TwoDigits(value.getMonth() + 1) +
                    '-' +
                    DateTimeFunctions.TwoDigits(value.getDate()) +
                    'T' +
                    DateTimeFunctions.TwoDigits(value.getHours()) +
                    ':' +
                    DateTimeFunctions.TwoDigits(value.getMinutes()) +
                    ':' +
                    DateTimeFunctions.TwoDigits(value.getSeconds())
                );
            }
            //LL:  for dates
            else if (format === 'custom') {
                //  value is Date
                if (customFormat == null || customFormat === '') {
                    return Globalize.formatDate(value, { datetime: 'full' });
                } else {
                    return Globalize.formatDate(value, { raw: customFormat });
                }
            } else if (timeInterval === true) {
                //LL: 08.04.25: add formatOptions //{use24hours: use24hours, firstDayOfWeek: firstWeekDay, fiscalFirstMonth: fiscalFirstMonth}
                //  IValueFormat:
                // use24hours?: boolean;
                // firstDayOfWeek?: string;
                // fiscalFirstMonth?: number;
                // { formatFront: format }
                let formatObj: any = { formatFront: format };
                if (formatOptions != null) {
                    // true, 'sun', '3'
                    _.extend(formatObj, formatOptions);
                }
                //LL:  timePart as 5th param ! and 2 args more
                return AttrQueryValuesFormat.formatValue(value, value.toString(), dataType, formatObj);
            } else {
                return value.toString();
            }
        };
    }
}

export class FontWrapper {
    public static createFontObj_fromValues(fontFace, fontSize, fontWeight) {
        let fontObj: any = {}; // color: fontColor

        if (fontFace != null) {
            fontObj.family = fontFace;
        } //    family: 'Zapf-Chancery, cursive',
        if (fontSize != null) {
            fontObj.size = fontSize;
        }
        if (fontWeight != null) {
            fontObj.weight = fontWeight;
        }

        return fontObj;
    }

    public static createFontObj(wParams, _theme, themeField_face, themeField_size, themeField_weight) {
        //  cursive ? is just a generic font name, it is not ~~ Italic
        let fontFace; //    family: 'Zapf-Chancery, cursive',
        if (_theme[themeField_face] != null) {
            fontFace = _theme[themeField_face];
        }
        let fontSize;
        if (_theme[themeField_size] != null && _theme[themeField_size] !== 'default') {
            fontSize = _theme[themeField_size];
        }
        //  Accepts values from 100 to 900 in increments of 100. Higher values increase boldness
        //  We have 'lighter','normal', 'bold', 'bolder'
        let fontWeight;
        if (_theme[themeField_weight] != null) {
            fontWeight = _theme[themeField_weight];
        }

        return FontWrapper.createFontObj_fromValues(fontFace, fontSize, fontWeight);
    }

    public static createFontObj_fromTheme(wParams, _theme, themeField_font) {
        let fontObj: any = {}; // color: fontColor

        let fontFromTheme;
        if (_theme[themeField_font] != null) {
            fontFromTheme = _theme[themeField_font];
        }

        if (fontFromTheme == null) {
            return fontObj;
        }

        return FontWrapper.createFontObj_fromValues(fontFromTheme.face, fontFromTheme.size, fontFromTheme.weight);
    }
}

export class SeriesXY_PointLabel_Wrapper {
    public static get_ownAxis(pointInfo) {
        let seriesTag = pointInfo.point.series.tag;
        let ownAxis;
        if (seriesTag != null) {
            if (seriesTag.isAuxAxis === true) {
                ownAxis = pointInfo.point.series.axis;
            }
        }
        //LL: not, because it will be ~~ "defaultAxis0":
        //let ownAxis = pointInfo.point.series.axis;
        return ownAxis;
    }

    public static formatSizeText(wParams, szValue, ownAxis) {
        let bubbleSizeFormat = wParams.valueAxis.bubbleSizeFormat;
        let bubbleSizePrecision = wParams.valueAxis.bubbleSizePrecision;

        if (ownAxis != null) {
            let ava = wParams.valueAxis.auxAxis;
            if (ava != null && ava.length > 0) {
                for (let i = 0; i < ava.length; i++) {
                    if (ava[i].name === ownAxis) {
                        bubbleSizeFormat = ava[i].bubbleSizeFormat;
                        bubbleSizePrecision = ava[i].bubbleSizePrecision;
                        break;
                    }
                }
            }
        }

        let sz = szValue;
        if (bubbleSizeFormat != null) {
            //LL:  pointInfo.size is of type string !!!
            if (typeof sz === 'string') {
                let K = parseFloat(sz);
                if (!isNaN(K)) {
                    sz = K;
                }
            }

            //LL: try format size, there is no built-in sizeText, nor sizeFormat, sizePrecision
            //  https://github.com/jquery/globalize/blob/0210060ee1669047319e9f72dd62b002e1eed494/README.md#numbers
            //  Currency: Globalize.format( 1234.56, "c" ); // $1,234.56
            // try:
            //sz = Globalize.format(sz, "c");
            //sz = Globalize.format(sz,"d3");
            //  was temporary:  Uncaught TypeError: Globalize.addCultureInfo is not a function   globalize.culture.ru-RU.js:31

            let currency = wParams.currency;
            sz = AttrQueryValuesFormat.formatNumeric(sz, {
                formatFront: bubbleSizeFormat,
                precision: bubbleSizePrecision,
                currency: currency
            });
        }
        return sz;
    }

    private static getPointLabel_TextFormat_standard(textFormat, seriesTag, vT, argText, wParams, pointInfo, totalTxt) {
        let s: any;
        switch (textFormat) {
            case 'value':
                s = vT;
                break;
            case 'argument':
                s = argText;
                break;
            case 'group':
            case 'stack':
                if (seriesTag != null) {
                    if (seriesTag.groupOnly != null) {
                        let what;

                        let formatsField;
                        let formatConfigKey;
                        if (seriesTag.x2 != null && textFormat === 'group') {
                            what = seriesTag.x2;
                            formatConfigKey = 'sbs';
                            formatsField = 'x2_formats';
                        } else if (seriesTag.x3 != null && textFormat === 'stack') {
                            what = seriesTag.x3;
                            formatConfigKey = 'stacked';
                            formatsField = 'x3_formats';
                        }
                        if (what != null) {
                            s = seriesTag.groupOnly;
                        }

                        if (s != null) {
                            s = LabelsFormatWrapper.getFormatted(
                                s,
                                null,
                                seriesTag,
                                formatsField,
                                wParams.currency,
                                'Labels',
                                formatConfigKey
                            );
                        }
                    }

                    if (
                        seriesTag.group != null &&
                        seriesTag.stack != null &&
                        seriesTag.x2 != null &&
                        seriesTag.x3 != null
                    ) {
                        //LL: x2-x3 vice versa !!!
                        let formatsField;
                        let formatConfigKey;

                        if (textFormat === 'group') {
                            s = seriesTag.stack; //LL: x2-x3 vice versa !!!
                            formatConfigKey = 'sbs';
                            formatsField = 'x2_formats';
                        } else {
                            s = seriesTag.group; //LL: x2-x3 vice versa !!!
                            formatConfigKey = 'stacked';
                            formatsField = 'x3_formats';
                        }

                        s = LabelsFormatWrapper.getFormatted(
                            s,
                            null,
                            seriesTag,
                            formatsField,
                            wParams.currency,
                            'Labels',
                            formatConfigKey
                        );
                    }
                }
                break;

            //LL: add pointInfo and totalTxt for total/percent, don't forget "fullStacked" with already percentText
            case 'total':
                //LL: with formatting as Values:
                if (totalTxt != null) {
                    s = totalTxt;
                }
                break;
            case 'percent':
                if (pointInfo.percentText != null) {
                    s = pointInfo.percentText;
                }
                break;

            case 'diffPercent':
                if (pointInfo.point.data != null && pointInfo.point.data.DiffPct != null) {
                    //LL: must be formatted, by now only so:
                    let dp = pointInfo.point.data.DiffPct;
                    dp = Math.round(dp);
                    s = dp.toString() + ' %';
                }
                break;
        }
        return s;
    }

    public static labelVisible = {
        visible: true
    };
    public static labelInvisible = {
        visible: false
    };

    //LL: for "onlyOneLabelPerStack":  label invisible for CommonSeriesSettings
    public static createPointLabelXY(
        wParams,
        _ArgumentAndPointLabels,
        _ArgumentAndPointLabels_Groups,
        _arrArgumentAndPointLabels,
        _arrArgumentAndPointLabels_Groups,
        chartWidgetObj,
        _argTimePart,
        _yTimePart,
        _aTimeParts,
        _theme
    ) {
        //  this is customization object series point labels

        //LL: for "onlyOneLabelPerStack":  label invisible for CommonSeriesSettings.
        //      But only if argCount=3 exists !!!
        //      And we must show Labels to other multiAQL series !!!
        //LL 2: NO, let's do another way:
        //      set Visible/Hidden in getSeriesSingle for case argCount === 3
        let vis = wParams.labelXY.show;

        //let self = this;

        let labelXY_obj: any = {
            visible: vis,
            rotationAngle: wParams.labelXY.rotationAngle,
            position: wParams.labelXY.position,
            verticalOffset: wParams.labelXY.verticalOffset,
            horizontalOffset: wParams.labelXY.horizontalOffset,
            alignment: wParams.labelXY.alignment,

            //format: { currency: currency },  //LL: will be set later using getLabelFormatAndPrecision

            customizeText: function (pointInfo) {
                //LL: see customizeTooltip
                let s = pointInfo.valueText; // = default

                let seriesTag = pointInfo.point.series.tag;

                let chartType = wParams.chartType;
                if (seriesTag != null) {
                    if (seriesTag.ownChartType != null) {
                        chartType = seriesTag.ownChartType;
                    }
                }

                let ownAxis = SeriesXY_PointLabel_Wrapper.get_ownAxis(pointInfo);

                let argText = LabelsFormatWrapper.getFormattedArgument(
                    pointInfo,
                    wParams,
                    chartWidgetObj,
                    _argTimePart,
                    'Labels'
                );

                let tp = _yTimePart;
                if (ownAxis != null && _aTimeParts != null && _aTimeParts[ownAxis] != null) {
                    tp = _aTimeParts[ownAxis];
                }
                let argCount = 1;
                if (seriesTag != null && seriesTag.counters != null && seriesTag.counters.argCount != null) {
                    argCount = seriesTag.counters.argCount;
                }
                let valueTxt = LabelsFormatWrapper.getFormattedValue(
                    pointInfo,
                    wParams,
                    chartWidgetObj,
                    tp,
                    ownAxis,
                    'Labels'
                );

                //LL: can be for Scatter:  xpCount_group  //LL: always
                //  It is spec case for Scatter:
                //      "Point Label" axis has aggreg = 'group'
                //      "Arguments" has aggr != 'group'
                //      So only grouping is by "Point Label" (validated)

                //LL: apply counts.xpCount ("Point Label" set in DataQuery) independently on labelXY.textFormat:
                //    For most Chart Types
                if (
                    !(
                        chartType === 'candlestick' ||
                        chartType === 'stock' ||
                        chartType === 'rangearea' ||
                        chartType === 'rangebar'
                    )
                ) {
                    let counts = seriesTag.counters;
                    if (
                        seriesTag != null &&
                        counts != null &&
                        ((counts.xpCount != null && counts.xpCount > 0) ||
                            (counts.xpCount_group != null && counts.xpCount_group > 0))
                    ) {
                        let labelText;
                        let argCount: number = counts.argCount;
                        let counterId = counts.counterId;

                        if (argCount === 1) {
                            let apl = _ArgumentAndPointLabels;
                            if (_arrArgumentAndPointLabels != null && _arrArgumentAndPointLabels.length > counterId) {
                                apl = _arrArgumentAndPointLabels[counterId];
                            }
                            if (apl != null) {
                                if (apl[pointInfo.argument] != null) {
                                    let pl = apl[pointInfo.argument].pointLabel;
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            'Labels',
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }

                        if (argCount === 2) {
                            let groupOnly = seriesTag.groupOnly;

                            let apl2 = _ArgumentAndPointLabels_Groups;
                            if (
                                _arrArgumentAndPointLabels_Groups != null &&
                                _arrArgumentAndPointLabels_Groups.length > counterId
                            ) {
                                apl2 = _arrArgumentAndPointLabels_Groups[counterId];
                            }
                            if (apl2 != null) {
                                if (apl2[groupOnly] != null) {
                                    let pl = apl2[groupOnly].pointLabel;
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            'Labels',
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }

                        if (argCount === 3) {
                            let group = seriesTag.group;
                            let stack = seriesTag.stack;

                            let apl3 = _ArgumentAndPointLabels_Groups;
                            if (
                                _arrArgumentAndPointLabels_Groups != null &&
                                _arrArgumentAndPointLabels_Groups.length > counterId
                            ) {
                                apl3 = _arrArgumentAndPointLabels_Groups[counterId];
                            }
                            if (apl3 != null) {
                                if (apl3[group] != null && apl3[group][stack] != null) {
                                    let pl = apl3[group][stack].pointLabel;
                                    if (pl != null && pl != '') {
                                        labelText = LabelsFormatWrapper.getFormatted(
                                            pl,
                                            null,
                                            seriesTag,
                                            'xP_formats',
                                            wParams.currency,
                                            'Labels',
                                            'pointLabel'
                                        );
                                    }
                                }
                            }
                        }

                        if (labelText != null) {
                            s = labelText;
                            return s;
                        }
                    }
                }

                if (chartType === 'candlestick' || chartType === 'stock') {
                    //LL: only 1 option: '4 values'

                    let oV: any = pointInfo.openValue;
                    let cV: any = pointInfo.closeValue;
                    let hV: any = pointInfo.highValue;
                    let lV: any = pointInfo.lowValue;

                    //LL:   openValueText	The openValue with an applied format and converted to string.
                    oV = LabelsFormatWrapper.getFormatted(
                        oV,
                        pointInfo.openValueText,
                        seriesTag,
                        'o_formats',
                        wParams.currency,
                        'Labels'
                    );
                    cV = LabelsFormatWrapper.getFormatted(
                        cV,
                        pointInfo.closeValueText,
                        seriesTag,
                        'c_formats',
                        wParams.currency,
                        'Labels'
                    );
                    hV = LabelsFormatWrapper.getFormatted(
                        hV,
                        pointInfo.highValueText,
                        seriesTag,
                        'h_formats',
                        wParams.currency,
                        'Labels'
                    );
                    lV = LabelsFormatWrapper.getFormatted(
                        lV,
                        pointInfo.lowValueText,
                        seriesTag,
                        'l_formats',
                        wParams.currency,
                        'Labels'
                    );

                    s = 'o=' + oV + ' c=' + cV + ' h=' + hV + ' l=' + lV;
                } else if (chartType === 'rangearea' || chartType === 'rangebar') {
                    //LL: only 1 option: '2 values'

                    //LL: 05.02.19:  there are changes in documentation for pointInfo:  "index"
                    //  index	0 - if the point is minimum; 1 - if the point is maximum. For range area and range bar series only.
                    //  originalValue	The raw value of the point.
                    //  value	The originalValue after type cast.
                    //  valueText	The value with an applied format and converted to string.
                    //s = pointInfo.valueText;

                    //LL: 08.02.19: changes in DevExpr
                    //   wParams.labelXY.textFormat_range
                    //  values: ['2 values', '2 labels'],
                    //  display: ['1 label with 2 values', '2 individual labels']
                    let fr = wParams.labelXY.textFormat_range;
                    if (fr === '2 values') {
                        // = 1 label near Max
                        if (pointInfo.index === 0) {
                            // Min label
                            s = '';
                        } else {
                            //LL: can use  pointInfo.point.minValue and pointInfo.point.value (= max)
                            //s = pointInfo.point.minValue + "-" + pointInfo.valueText;
                            s =
                                LabelsFormatWrapper.getFormatted(
                                    pointInfo.point.minValue,
                                    null,
                                    seriesTag,
                                    'yMin_formats',
                                    wParams.currency,
                                    'Labels'
                                ) +
                                '-' +
                                LabelsFormatWrapper.getFormatted(
                                    pointInfo.value,
                                    pointInfo.valueText,
                                    seriesTag,
                                    'yMax_formats',
                                    wParams.currency,
                                    'Labels'
                                );
                        }
                    } else {
                        //  '2 labels'
                        let formatKey = pointInfo.index === 0 ? 'yMin_formats' : 'yMax_formats';
                        s = LabelsFormatWrapper.getFormatted(
                            pointInfo.value,
                            pointInfo.valueText,
                            seriesTag,
                            formatKey,
                            wParams.currency,
                            'Labels'
                        );
                    }
                } else if (chartType === 'bubble') {
                    let sz: any = pointInfo.size;
                    sz = SeriesXY_PointLabel_Wrapper.formatSizeText(wParams, sz, ownAxis);

                    let tfm = wParams.labelXY.textFormat_bubble_multi;
                    s = sz;
                    if (tfm != null && tfm.length !== 0) {
                        //LL: order as selected:   and no need in _hasArgument, _hasValue, etc
                        s = '';

                        let extendedLabelMode = false;
                        if (
                            _theme != null &&
                            _theme[themeFields.pointLabels_showInLabel_bubble_addValueDataLabel] != null
                        ) {
                            extendedLabelMode = _theme[themeFields.pointLabels_showInLabel_bubble_addValueDataLabel];
                        }

                        for (let i = 0; i < tfm.length; i++) {
                            let s1 = '';
                            switch (tfm[i]) {
                                case 'value':
                                    s1 = valueTxt;
                                    if (extendedLabelMode) {
                                        let labY = 'value';
                                        if (seriesTag != null) {
                                            labY = seriesTag.y;
                                        }
                                        s1 = labY + ': ' + s1;
                                    }
                                    break;
                                case 'size':
                                    s1 = sz;
                                    s1 = LabelsFormatWrapper.getFormatted(
                                        pointInfo.size,
                                        sz,
                                        seriesTag,
                                        'zSize_formats',
                                        wParams.currency,
                                        'Labels'
                                    );
                                    if (extendedLabelMode) {
                                        let labZ = 'size';
                                        if (seriesTag != null) {
                                            labZ = seriesTag.zSize;
                                        }
                                        s1 = labZ + ': ' + s1;
                                    }
                                    break;
                                case 'argument':
                                    s1 = argText;
                                    break;
                            }
                            if (s.length > 0) {
                                s += '; ';
                            }
                            s += s1;
                        }
                    }
                } else {
                    // standard
                    let vT = valueTxt;
                    //LL: for fullStacked:
                    if (wParams.fullStacked === true && pointInfo.percentText != null) {
                        vT += ' (' + pointInfo.percentText + ')';
                    }

                    let tfm = wParams.labelXY.textFormat_standard_multi;
                    s = vT;
                    if (tfm != null && tfm.length !== 0) {
                        //LL: forTotalValue: similar to valueTxt
                        let totalTxt = pointInfo.totalText;
                        let tp = _yTimePart;
                        let ownAxis = SeriesXY_PointLabel_Wrapper.get_ownAxis(pointInfo);
                        if (ownAxis != null && _aTimeParts != null && _aTimeParts[ownAxis] != null) {
                            tp = _aTimeParts[ownAxis];
                        }
                        //LL: add forTotalValue (same formatting as for Value)
                        totalTxt = LabelsFormatWrapper.getFormattedValue(
                            pointInfo,
                            wParams,
                            chartWidgetObj,
                            tp,
                            ownAxis,
                            'Labels',
                            true
                        );

                        //LL: order as pre-selected:
                        s = '';
                        for (let i = 0; i < tfm.length; i++) {
                            //LL: add pointInfo and totalTxt for total/percent, don't forget "fullStacked" with already percentText
                            //LL:  tfm-value -> tfm-total
                            let tfmItem = tfm[i];
                            if (wParams.onlyOneLabelPerStack === true) {
                                if (tfmItem === 'value' && seriesTag.counters.argCount === 3) {
                                    tfmItem = 'total';
                                }
                            }
                            let si = SeriesXY_PointLabel_Wrapper.getPointLabel_TextFormat_standard(
                                tfmItem,
                                seriesTag,
                                vT,
                                argText,
                                wParams,
                                pointInfo,
                                totalTxt
                            );

                            if (tfmItem === 'value') {
                                let extendedLabelMode = false;
                                if (
                                    _theme != null &&
                                    _theme[themeFields.pointLabels_showInLabel_standard_addValueDataLabel] != null
                                ) {
                                    extendedLabelMode =
                                        _theme[themeFields.pointLabels_showInLabel_standard_addValueDataLabel];
                                }
                                if (extendedLabelMode) {
                                    let labY = 'value';
                                    if (seriesTag != null) {
                                        labY = seriesTag.y;
                                    }
                                    si = labY + ': ' + si;
                                }
                            }

                            if (si != null) {
                                if (s.length > 0) {
                                    s += '; ';
                                }
                                s += si;
                            }
                        }
                    }
                }
                return s;
            },

            connector: {
                visible: wParams.labelXY.connectorVisible
                // color, width
            },
            border: {
                visible: wParams.labelXY.borderVisible,
                // dashStyle - solid, width - 1
                color: wParams.labelXY.borderColor // def '#d3d3d3'
            }
        };
        if (wParams.labelXY.useDefaultColor === false) {
            labelXY_obj.backgroundColor = wParams.labelXY.backgroundColor;
            labelXY_obj.font = { color: wParams.labelXY.fontColor };
        }

        let fo = FontWrapper.createFontObj_fromTheme(wParams, _theme, themeFields.font_inPointLabels);
        if (labelXY_obj.font == null) {
            labelXY_obj.font = {};
        }
        _.extend(labelXY_obj.font, fo); // shallow

        //LL: percentPrecision used for full-stacked.  Maybe do not set it, it will by 0 by default
        //format: { percentPrecision: 2 },

        return labelXY_obj;
    }

    //LL: ===  try to customize ligth/dark label.font.color: ===
    public static smartFontColor_ForSeriesPointLabels(wParams, series, labelXY_common) {
        //LL:  when labelXY.useDefaultColor === false && labelXY.backgroundColor === 'transparent'
        //          and wParams.labelXY.position === 'inside'

        if (
            wParams.labelXY.useDefaultColor === false &&
            wParams.labelXY.backgroundColor === 'transparent' &&
            wParams.labelXY.position === 'inside'
        ) {
            let fColor = wParams.labelXY.fontColor;
            let middleColor = '888888'; // without #
            let m = parseInt(middleColor, 16);
            let middlePartColor = '88'; // without #
            let mp = parseInt(middlePartColor, 16); // 136
            let white = parseInt('ffffff', 16);
            if (fColor.substring(0, 1) === '#') {
                let nColor = fColor.substring(1);
                let num = parseInt(nColor, 16);
                if (!isNaN(num)) {
                    let isLight = num > m;
                    //LL: isLight - not proper evaluation, must be for each r,g,b separately
                    //    but let it be for default color

                    let cColor = (white - num).toString(16);
                    let l = 6 - cColor.length;
                    for (let i = 0; i < l; i++) {
                        cColor = '0' + cColor;
                    }
                    let complementaryColor = '#' + cColor;

                    for (let i = 0; i < series.length; i++) {
                        let sColor = series[i].color;
                        if (sColor != null && sColor.substring(0, 1) === '#') {
                            let nsColor = sColor.substring(1);
                            let ns = parseInt(nsColor, 16);
                            if (!isNaN(ns)) {
                                //LL: isLight - not proper evaluation, must be for each r,g,b separately
                                //let sLight = (ns > m);

                                let o: any = Utils.ColorHexWrapper.hexToRgb(sColor);
                                let sLight = o.r > mp && o.g > mp && o.b > mp;

                                if (isLight === sLight) {
                                    //LL: use complementaryColor for font
                                    let lab = $.extend(true, {}, labelXY_common);
                                    if (lab.font == null) {
                                        lab.font = {};
                                    }
                                    lab.font.color = complementaryColor;
                                    series[i].label = lab;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

export class ConstantLinesWrapper {
    //LL: when useDataQuerySingleValueField: true,
    public static produceDataQueryArray(ConstantLines) {
        // array
        let dqa = [];
        _.each(ConstantLines, function (obj: any, index) {
            if (obj.fromDataSource === true) {
                if (DataQuerySingleValueField.validateQuery(obj.dataQuery)) {
                    let title = 'ConstantLine_' + index;

                    obj.valueDataSourceTitle = title;

                    //  validated obj.dataQuery is array[1]
                    let query = obj.dataQuery[0];
                    let query2 = $.extend(true, { title: title }, query);
                    dqa.push(query2);
                }
            }
        });
        return dqa;
    }

    private wParams: any = {};

    constructor(_wParams) {
        this.wParams = _wParams;
    }

    public createConstantLineCommonStyle(_theme) {
        let constantLineCommonStyle: any = {
            color: this.wParams.axisConstantLines.colorDefault,
            dashStyle: this.wParams.axisConstantLines.dashStyleDefault, // any combination dash, dot, longDash
            width: this.wParams.axisConstantLines.widthDefault,
            label: {
                visible: true,
                position: this.wParams.axisConstantLines.labelPositionDefault, // 'outside', 'inside',
                font: {
                    color: this.wParams.axisConstantLines.labelFontColorDefault
                }
            }
        };

        let fo = FontWrapper.createFontObj_fromTheme(this.wParams, _theme, themeFields.font_inConstLines);
        if (fo != null) {
            let foKeys = _.keys(fo);
            if (foKeys.length > 0) {
                if (constantLineCommonStyle.label.font == null) {
                    constantLineCommonStyle.label.font = {};
                }
                _.extend(constantLineCommonStyle.label.font, fo); // shallow
            }
        }

        return constantLineCommonStyle;
    }

    public createConstantLines(argType, yType, dataOneDim, glob: IGlob) {
        let constantLinesX = [];
        let constantLinesY = [];
        let constantLinesA = {}; // each: { key: AUX1, { constantLines: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }

        let constantLines_canAsPercentX = false;
        let constantLines_canAsPercentY = false;
        constantLines_canAsPercentX = ChartFunctionsWrapper.evalCanAsPercent_ForArgumentAxis(this.wParams, argType);
        constantLines_canAsPercentY = ChartFunctionsWrapper.evalCanAsPercent_ForValueAxis(this.wParams, yType);

        let constantLines_hasAsPercentX = false;
        let constantLines_hasAsPercentY = false;
        let constantLines_hasAsPercentA = false;
        let constantLines_wrongAsPercentX = false;
        let constantLines_wrongAsPercentY = false;
        let constantLines_wrongAsPercentA = false;

        let constantLines_wrongDataTypeX = false;
        let constantLines_wrongDataTypeY = false;
        let constantLines_wrongDataTypeA = false;

        for (let i = 0; i < this.wParams.axisConstantLines.constantLines.length; i++) {
            let constantLineDef = this.wParams.axisConstantLines.constantLines[i];

            let val: any = constantLineDef.value;
            let dataType = null; //  was not before
            if (constantLineDef.fromDataSource === true) {
                if (constantLineDef.valueDataSourceTitle == null) {
                    //  warning ?
                    continue;
                }
                if (dataOneDim == null || dataOneDim[constantLineDef.valueDataSourceTitle] == null) {
                    //  warning ?
                    continue;
                }
                val = dataOneDim[constantLineDef.valueDataSourceTitle].value;
                if (val == null) {
                    continue;
                }
                dataType = dataOneDim[constantLineDef.valueDataSourceTitle].type;
            }

            let labelText = constantLineDef.label;
            //LL: decided not to do it:
            //if (labelText == null || labelText.trim() === '') {
            //    if (constantLineDef.fromDataSource === true) {
            //        labelText = constantLineDef.valueDataSourceTitle;
            //    }
            //}

            let constantLine: any = {
                //extendAxis: true, //LL: try
                value: val,
                asPercentLL: false,
                color:
                    constantLineDef.color != null ? constantLineDef.color : this.wParams.axisConstantLines.colorDefault,
                dashStyle: constantLineDef.dashStyle,
                width: constantLineDef.width,
                //LL: 27.11.17: added as a workaround of DevExpr bug:  (some value must be set)
                paddingTopBottom: 0, //LL: otherwise "top" label is not shown for vert line when no Title (no space above Chart !)
                paddingLeftRight: 0, //LL: otherwise "outside" label is not shown for horiz line on the opposite side of axis (no space above Chart !)
                label: {
                    visible: true,
                    font: {
                        color:
                            constantLineDef.fontColor != null
                                ? constantLineDef.fontColor
                                : this.wParams.axisConstantLines.labelFontColorDefault
                    },
                    text: labelText, //constantLineDef.label,
                    //position: constantLineDef.labelPosition,
                    verticalAlignment: 'center',
                    horizontalAlignment: 'center'
                }
            };

            if (constantLineDef.labelPosition != null) {
                //LL: def "inside"
                constantLine.label.position = constantLineDef.labelPosition;
            }

            if (constantLineDef.type === 'values') {
                //  if (! wParams.rotatedXY) {
                constantLine.label.horizontalAlignment = constantLineDef.labelHorizontalAlignment;
                constantLine.label.verticalAlignment = constantLineDef.labelVerticalAlignment;
                if (constantLines_canAsPercentY && constantLineDef.asPercent != null) {
                    constantLine.asPercentLL = constantLineDef.asPercent;
                    if (constantLine.asPercentLL === true) {
                        constantLines_hasAsPercentY = true;
                    }
                }
                let wrong = false;
                if (!constantLines_canAsPercentY && constantLineDef.asPercent === true) {
                    constantLines_wrongAsPercentY = true;
                    wrong = true;
                }

                if (!wrong && dataType != null) {
                    let wrongDataTypeY = StripsWrapper.compareDataTypes(yType, dataType);
                    if (wrongDataTypeY) {
                        wrong = true;
                    }
                    constantLines_wrongDataTypeY = constantLines_wrongDataTypeY || wrongDataTypeY;
                    if (wrong) {
                        console.log('ConstLine values: wrong data type: yType = ' + yType + ' dataType = ' + dataType);
                    }
                }

                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(yType)) {
                        let aDate = StripsWrapper.convertToDateTime(yType, val);

                        if (aDate == null) {
                            wrong = true;
                        } else {
                            constantLine.value = aDate;
                        }
                    }
                    if (wrong) {
                        console.log('ConstLine values: wrong data type: yType = ' + yType + ' value = ' + val);
                    }
                }

                if (!wrong) {
                    constantLinesY.push(constantLine);
                } // warning ?
            } else if (constantLineDef.type === 'arguments') {
                //  if (! wParams.rotatedXY) {
                constantLine.label.horizontalAlignment = constantLineDef.labelHorizontalAlignment;
                constantLine.label.verticalAlignment = constantLineDef.labelVerticalAlignment;

                //  include in upper default
                //  Generates a pixel-measured empty space between the top/bottom side of a constant line and the constant line label.
                //  Default Value: 10
                //
                // This option depends on the label.verticalAlignment in the following way.
                //  verticalAlignment is "top" -> padding applies to the top side of a constant line;
                //  verticalAlignment is "bottom" -> padding applies to the bottom side of a constant line;
                //  verticalAlignment is "center" -> padding is calculated automatically.
                //paddingTopBottom: 15,  // 10 def
                //constantLine.paddingTopBottom = 10;  // set default
                //constantLine.paddingTopBottom = 0;

                if (constantLines_canAsPercentX && constantLineDef.asPercent != null) {
                    constantLine.asPercentLL = constantLineDef.asPercent;
                    if (constantLine.asPercentLL === true) {
                        constantLines_hasAsPercentX = true;
                    }
                }
                let wrong = false;
                if (!constantLines_canAsPercentX && constantLineDef.asPercent === true) {
                    constantLines_wrongAsPercentX = true;
                    wrong = true;
                }

                if (!wrong && dataType != null) {
                    let wrongDataTypeX = StripsWrapper.compareDataTypes(argType, dataType);
                    if (wrongDataTypeX) {
                        wrong = true;
                    }
                    constantLines_wrongDataTypeX = constantLines_wrongDataTypeX || wrongDataTypeX;
                    if (wrong) {
                        console.log(
                            'ConstLine arguments: wrong data type: argType = ' + argType + ' dataType = ' + dataType
                        );
                    }
                }

                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(argType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(argType, val);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            constantLine.value = aDate;
                        }
                    }
                    if (wrong) {
                        console.log('ConstLine values: wrong data type: argType = ' + argType + ' value = ' + val);
                    }
                }

                if (!wrong) {
                    constantLinesX.push(constantLine);
                }
            } else {
                //  each in constantLinesA: { key: AUX1, { constantLines: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }
                let axisName = constantLineDef.type;

                if (constantLinesA[axisName] == null) {
                    constantLinesA[axisName] = {
                        constantLines: [],
                        canAsPercent: false,
                        hasAsPercent: false,
                        wrongAsPercent: false
                    };
                    //LL: canAsPercent must be evaluated
                    constantLinesA[axisName].canAsPercent = ChartFunctionsWrapper.evalCanAsPercent_ForAuxAxis(
                        this.wParams,
                        axisName,
                        glob
                    );

                    //LL: here also dataType of axis
                    let oDataType = ChartFunctionsWrapper.evalAuxAxisType(this.wParams, axisName, glob); // return { yType: yType, yTimePart: yTimePart  }
                    let aaType = oDataType.yType;
                    if (oDataType.yTimePart != null) {
                        aaType = oDataType.yTimePart;
                    }
                    constantLinesA[axisName].dataType = aaType;
                }

                let canAsPercentA = constantLinesA[axisName].canAsPercent;

                let aType = constantLinesA[axisName].dataType;

                constantLine.label.horizontalAlignment = constantLineDef.labelHorizontalAlignment;
                constantLine.label.verticalAlignment = constantLineDef.labelVerticalAlignment;
                if (canAsPercentA && constantLineDef.asPercent != null) {
                    constantLine.asPercentLL = constantLineDef.asPercent;
                    if (constantLine.asPercentLL === true) {
                        constantLinesA[axisName].hasAsPercent = true;
                        constantLines_hasAsPercentA = true;
                    }
                }
                let wrong = false;
                if (!canAsPercentA && constantLineDef.asPercent === true) {
                    constantLinesA[axisName].wrongAsPercent = true;
                    constantLines_wrongAsPercentA = true;
                    wrong = true;
                }

                if (!wrong && dataType != null) {
                    let wrongDataTypeA = StripsWrapper.compareDataTypes(aType, dataType);
                    if (wrongDataTypeA) {
                        wrong = true;
                    }
                    constantLines_wrongDataTypeA = constantLines_wrongDataTypeA || wrongDataTypeA;
                    if (wrong) {
                        console.log(
                            'ConstLine AUX values: wrong data type: aType = ' + aType + ' dataType = ' + dataType
                        );
                    }
                }

                //LL: convert value to Date/Time if needed
                //LL: DB values for date-time must be converted also, especially "time"
                if (!wrong) {
                    if (DateTimeFunctions.isTypeOfAnyDate(aType)) {
                        let aDate: any = StripsWrapper.convertToDateTime(aType, val);
                        if (aDate == null) {
                            wrong = true;
                        } else {
                            constantLine.value = aDate;
                        }
                    }
                    if (wrong) {
                        console.log('ConstLine AUX values: wrong data type: aType = ' + aType + ' value = ' + val);
                    }
                }

                if (!wrong) {
                    constantLinesA[axisName].constantLines.push(constantLine);
                }
            }
        }

        if (constantLines_wrongDataTypeX) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for Argument Axis have wrong Data Type in Value Query.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }
        if (constantLines_wrongDataTypeY) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for Value Axis have wrong Data Type in Value Query.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }
        if (constantLines_wrongDataTypeA) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for AUX Value Axis have wrong Data Type in Value Query.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }

        if (constantLines_wrongAsPercentX) {
            //LL: <br>, not '\n'  -- will be inside <span> :
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for Argument Axis have "As Percent" option set, but Argument Axis is discrete or is of date-time type.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }
        if (constantLines_wrongAsPercentY) {
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for Value Axis have "As Percent" option set, but Value Axis is discrete or is of date-time type.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }
        if (constantLines_wrongAsPercentA) {
            NotificationCallWrapper.notify(
                'warning',
                'Some Constant Lines for a Secondary Value Axis have "As Percent" option set, but this Secondary Value Axis is discrete or is of date-time type.<br>' +
                    'Such Constant Lines are not shown<br>',
                true
            );
        }

        let constantLinesObj = {
            constantLinesX: constantLinesX,
            constantLinesY: constantLinesY,
            constantLinesA: constantLinesA, // each: { key: AUX1, { constLine: [], canAsPercent: , hasAsPercent: , wrongAsPercent: }
            constantLines_hasAsPercentX: constantLines_hasAsPercentX,
            constantLines_hasAsPercentY: constantLines_hasAsPercentY,
            constantLines_hasAsPercentA: constantLines_hasAsPercentA
        };

        return constantLinesObj;
    }

    public applyAsPercent(constantLines, max) {
        if (constantLines == null) {
            //LL: for AUX axis
            return;
        }
        for (let i = 0; i < constantLines.length; i++) {
            let constantLine: any = constantLines[i];
            if (constantLine.asPercentLL) {
                let val = constantLine.value;
                let num = Number(val);
                if (!isNaN(num)) {
                    val = num;
                }
                constantLine.value = (val * max) / 100;
            }
        }
    }
}

export class ChartData {
    public static getData_Leo_3(
        WidgetDescriptor,
        widgetOptions: IWidgetOptionsBase,
        glob: IGlob,
        allowApplyData: boolean,
        callback: (data: {
            multi: boolean;
            dataArr: any[];
            ageFromBackend: number;
            dataOneDim: { [title: string]: any };
        }) => void
    ) {
        if (WidgetDescriptor.AQM != null && WidgetDescriptor.AQM.length > 0) {
            if (!allowApplyData) {
                //Issue 73957: Showing this message within a widget produces isses in inline mode.
                glob.AppActions.showNotification_Warning('Click Apply button to show values');
                return;
            }

            let arrMWD = WidgetDescriptor.AQM;

            //  shallow copy of arrMWD:
            let arrMWD_2 = [];

            _.each(arrMWD, function (WD: any) {
                arrMWD_2.push(WD);
            });

            let aqOneDim = WidgetDescriptor.aqOneDim; //  object:   {  "title": aq  }
            let aqOneDimCount = 0;

            if (aqOneDim != null) {
                _.each(aqOneDim, function (qod: any) {
                    arrMWD_2.push(qod);
                    aqOneDimCount++;
                });
            }

            $.when
                .apply(
                    $,
                    $.map(arrMWD_2, function (WD: any) {
                        const def = $.Deferred();

                        ChartData.getData(WD, widgetOptions, glob, (objData) => {
                            WD.dataFromDB = objData;
                            def.resolve();
                        });

                        return def;
                    })
                )
                .then(function () {
                    let dataA = {
                        multi: true,
                        dataArr: [],
                        ageFromBackend: 0,
                        dataOneDim: {}
                    };

                    let ageFromBackendArr: number[] = [0];

                    for (let i = 0; i < arrMWD.length; i++) {
                        dataA.dataArr.push(arrMWD[i].dataFromDB);
                        ageFromBackendArr.push(arrMWD[i].dataFromDB.age);
                    }

                    dataA.ageFromBackend = _.max(ageFromBackendArr);

                    if (aqOneDim != null) {
                        _.each(aqOneDim, function (qod, key) {
                            dataA.dataOneDim[key] = qod.dataFromDB;
                        });
                    }

                    callback(dataA);
                });
        }
    }

    //LL: public for use in WidgetStore
    //LL: params is WD.argGetValueSet
    public static clean_argGetValueSet(params: any) {
        let defaults = {
            limit: 0,
            attrib_refs: [],
            group_attribs: [],
            filter: []
        };

        let actualParams = $.extend(true, {}, defaults, params);

        for (let k = 0; k < actualParams.attrib_refs.length; k++) {
            let a = actualParams.attrib_refs[k];
            delete a.label;
            delete a.attribType;
            delete a.attribRefer;
            delete a.attrRefer;
            delete a.DefaultAttributeType;
            delete a.formatFront;
            delete a.axis;
            delete a.x1;
            delete a.x2;
            delete a.x3;
            delete a.zSize;
            delete a.yOpen;
            delete a.yClose;
            delete a.yHigh;
            delete a.yLow;
            delete a.yMin;
            delete a.yMax;
            delete a.xC;
            delete a.xL;
            delete a.xP;
            delete a.stackP;
            delete a.C2F;
            delete a.A;
            delete a.T;
            delete a.SBT;
            delete a.clickToFilterAttribute;
            delete a.intervalsData; //LL: were added to transfer to ClickToFilter as a whole set
            delete a.formats;
            delete a.showInTooltip;
            delete a.customStyle;
            delete a.mapping;
            delete a.sourceParamValue;
        }
        for (let k = 0; k < actualParams.group_attribs.length; k++) {
            let a = actualParams.group_attribs[k];
            delete a.label;
            delete a.attribType;
            delete a.attribRefer;
            delete a.attrRefer;
            delete a.DefaultAttributeType;
            delete a.formatFront;
            delete a.axis;
            delete a.x1;
            delete a.x2;
            delete a.x3;
            delete a.zSize;
            delete a.yOpen;
            delete a.yClose;
            delete a.yHigh;
            delete a.yLow;
            delete a.yMin;
            delete a.yMax;
            delete a.A;
            delete a.T;
            delete a.SBT;
            delete a.clickToFilterAttribute;
            delete a.intervalsData; //LL: were added to transfer to ClickToFilter as a whole set
            delete a.formats;
            delete a.showInTooltip;
            delete a.customStyle;
            delete a.mapping;
            delete a.sourceParamValue;
        }

        if (actualParams.distinct === false) {
            delete actualParams.distinct;
        }

        if (actualParams.queryRootEntity === 'default') {
            delete actualParams.queryRootEntity;
        }

        return actualParams;
    }

    private static getData(
        widgetDescriptor: any,
        widgetOptions: IWidgetOptionsBase,
        glob: IGlob,
        callback: (obj) => void
    ) {
        //LL: Leo input for GetValueSet():
        //  GetValueSet( Culture, (Attribute-Reference)*, Filter, (Grouping-Attribute)*)->ValueSet

        const obj: {
            valuesLeo: string[][];
            typeList: string[];
            age?: number;
        } = {
            valuesLeo: [],
            typeList: []
        };

        let fltr = [];
        //EVG 19.11.2019: merging with an empty array has no sense. This function does only a copy of localFilter now, but it is not needed here.
        fltr = this.mergeWithLocalFilterObject(fltr, widgetDescriptor.localFilter);

        let argGetValueSet: IDataParameters = {
            attrib_refs: [],
            group_attribs: [],
            filter: fltr,
            dataSourceID: null //EVG: dataSourceID is demanded by interface. I have set it here just to make it compiled.
        };

        if (widgetDescriptor.argGetValueSet != null) {
            argGetValueSet = $.extend(
                true,
                argGetValueSet,
                ChartData.clean_argGetValueSet(widgetDescriptor.argGetValueSet)
            );
        }

        //LL: by Leo's request, always True
        argGetValueSet.specialMainGroupHandling = true;

        const def = glob.AQLQueries.loadData(argGetValueSet, widgetOptions);

        def.then((data) => {
            if (data != null) {
                if (data.result == null || data.result.length === 0) {
                    console.log('Charts..Parametrized getData: data is empty');
                }

                //LL: when Canceling Data Query(new functionality):
                //    before data.result was not null, only data.result.length
                if (data.result == null) {
                    console.log('Charts..Parametrized getData: data NULL');
                } else {
                    obj.valuesLeo = data.result;
                    obj.typeList = data.typeList;
                    obj.age = data.age;
                }
            }

            callback(obj);
        }).fail(() => {
            callback(obj);
        });

        return def;
    }

    public static setData(WidgetDescriptor, data) {
        WidgetDescriptor.dataFromDB = data;
    }

    private static mergeWithLocalFilterObject(fltr, localFilter) {
        if (localFilter != null && localFilter.filter != null && localFilter.filter.length > 0) {
            let fltrOver = [];
            for (let k = 0; k < fltr.length; k++) {
                let f = $.extend(true, {}, fltr[k]);
                fltrOver.push(f);
            }
            for (let i = 0; i < localFilter.filter.length; i++) {
                fltrOver.push($.extend(true, {}, localFilter.filter[i]));
            }
            fltr = fltrOver;
        }
        return fltr;
    }

    //LL:  ~~copy of same in Module  self.state.globalState -> globalState, self.props.glob -> glob
    //LL: Used in WidgetStore.ts, Module.tsx (?)
    public static bindExpressionVariables(
        widgetParameters: IWidgetParameters,
        widgetId: number,
        glob: IGlob,
        globalState: GlobalState,
        scopeOptions: IScopeOptions
    ) {
        let error = false;
        let widgetParamsNew: IWidgetParameters;
        let attrQueries = widgetParameters.attrQueryMulti.attrQueries;
        let hasExpression = false;

        //  It's also good to note that an _.each loop cannot be broken out of — to break, use _.find instead.
        //      _.find
        //  Looks through each value in the list, returning the first one that passes a truth test (predicate),
        //      or undefined if no value passes the test.
        //  The function returns as soon as it finds an acceptable element, and doesn't traverse the entire list.

        let fnd = _.find(attrQueries, (attrQuery: any, k) => {
            if (attrQuery.parameters.used !== false) {
                let dd = attrQuery.dataDescriptor; // arr
                let withExpr = _.find(dd, (item: any, m) => {
                    //  either .attribute or .expression
                    return item.expression != null;
                });
                return withExpr != null; // is break
            } else {
                return false;
            }
        });
        hasExpression = fnd != null;

        //LL: if hasExpression => clone widgetParams

        if (hasExpression) {
            widgetParamsNew = $.extend(true, {}, widgetParameters);
            attrQueries = widgetParamsNew.attrQueryMulti.attrQueries;

            let fnd = _.find(attrQueries, (attrQuery, k) => {
                if (attrQuery.parameters.used !== false) {
                    const dataSourceID = attrQuery.dataSourceID;

                    let dd = attrQuery.dataDescriptor; // arr
                    let bindErrItem = _.find(dd, (item: any, m) => {
                        //  either .attribute or .expression
                        if (item.expression != null) {
                            const boundExpr = globalState.expressionBindVariables(
                                item.expression,
                                dataSourceID,
                                widgetId,
                                scopeOptions
                            );
                            if (boundExpr == null) {
                                glob.AppActions.cleanWidgetNotifications(widgetId);
                                glob.AppActions.showNotification_Warning('error in expressionBindVariables', widgetId);
                                //self._erroneous = true;
                                return true; // is break
                            } else {
                                item.expression = boundExpr; //   copy of widgetParams  !!!
                            }
                        }
                        return false; // continue
                    }); // _.find(dd

                    if (bindErrItem != null) {
                        return true; // is break
                    }
                } else {
                    //   NOT  parameters.used
                    return false; // continue
                }

                return false; // continue
            }); //  _.find(attrQueries

            if (fnd != null) {
                error = true;
                widgetParamsNew = null;
            }
        }

        return { error: error, widgetParamsNew: widgetParamsNew }; // also set self._erroneous in Module !
    }
}
